import * as RH from '@radix-ui/react-hover-card'
import type { ComponentProps } from 'react'
import { cn } from './cn'
import { floatingPanel } from './popover-styles'
import { usePrivateAttrs } from './privateArea'

/** Hover preview (for example user cards on name hover). Open delay 400ms, close delay 150ms. */
export function HoverCard({ openDelay = 400, closeDelay = 150, ...rest }: ComponentProps<typeof RH.Root>) {
  return <RH.Root openDelay={openDelay} closeDelay={closeDelay} {...rest} />
}

export const HoverCardTrigger = RH.Trigger

export function HoverCardContent({
  className,
  sideOffset = 8,
  collisionPadding = 8,
  align = 'start',
  ...rest
}: ComponentProps<typeof RH.Content>) {
  const priv = usePrivateAttrs()
  return (
    <RH.Portal>
      <RH.Content
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        align={align}
        className={cn(floatingPanel, 'w-80 p-4', className)}
        {...priv}
        {...rest}
      />
    </RH.Portal>
  )
}
